import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { PagingAndOrderingModel } from '@common/models/common/PagingAndOrdering.model';

export class ContainerListFilter extends PagingAndOrderingModel {
    cargoManifestId: number;
    serviceRequestId: number;
    vesselVisitVoyage: string;
    system: string;
    operatorId: string;
    terminal: string;
    pod: string;
    pol: string;
    line: string;
    fe: string;
    booking: string;
    iso: string;
    manipulationId: string;
    containers: string;
    billOfLading: string;
    agentId: number;

    constructor(pageFilter?: PagingAndOrderingModel, data = null) {
        super();

        if (data) {
            Object.assign(this, data);
        }
    }

    createFormGroup() {
        const form = new UntypedFormGroup({
            cargoManifestId: new UntypedFormControl({ value: null, disabled: false }),
            vesselVisitVoyage: new UntypedFormControl({ value: null, disabled: false }),
            system: new UntypedFormControl({ value: null, disabled: false }),
            operatorId: new UntypedFormControl({ value: null, disabled: true }),
            terminal: new UntypedFormControl({ value: null, disabled: true }),
            pod: new UntypedFormControl({ value: null, disabled: false }),
            pol: new UntypedFormControl({ value: null, disabled: false }),
            line: new UntypedFormControl({ value: null, disabled: false }),
            fe: new UntypedFormControl({ value: null, disabled: false }),
            booking: new UntypedFormControl({ value: null, disabled: false }),
            billOfLading: new UntypedFormControl({ value: null, disabled: false }),
            iso: new UntypedFormControl({ value: null, disabled: false }),
            manipulationId: new UntypedFormControl({ value: null, disabled: true }),
            containers: new UntypedFormControl({ value: null, disabled: false })
        });
        form.patchValue(this);
        return form;
    }
}
